import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import UserProfileNoImg from "@/../../public/images/no-image.jpg";
import { LuDownload } from "react-icons/lu";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useLocation } from "react-router-dom";
import {
  applicantStatusUpdate,
  appliedJobDetails,
  deleteApplicant,
  jobApplicantList,
  jobApplicantListTable,
} from "../../service/apis/auth.api";
import { showError, showSuccess } from "../../utils/Common";
import moment from "moment";
import { ApplicationDetails } from "../../config/ApplicantDetails";
import _ from "lodash";
import { statusOptions } from "../../config/Status";
import DataTable from "../../common/data-table";
import Loader from "../../common/Loader/loader";
import { Alert } from "../../common/Alert/alert";

const EmpApplicantsScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [applications, setApplications] = useState<any>({});
  const [draggedApplication, setDraggedApplication] = useState<any>(null);
  const [applicantDetails, setApplicantDetails] =
    useState<ApplicationDetails>();
  const [totalPages, setTotalPages] = useState(1);
  const [applicantTableData, setApplicantTableData] = useState([]);

  const location = useLocation();
  const { jobId } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [activeTab, setActiveTab] = useState("home");

  const columns = [
    { label: "Candidate Name", key: "name" },
    { label: "Applied Date", key: "applied_date" },
    { label: "Status", key: "status" },
    { label: "Position Applied For", key: "position_applied_for" },
    { label: "Post Date", key: "post_date" },
    { label: "", key: "hire_me" },
    { label: "Actions", key: "actions" },
  ];

  useEffect(() => {
    fetchjobApplicantListTable(jobId);
    fetchjobApplicantList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  const fetchjobApplicantList = async () => {
    try {
      // setLoading(true);
      const response = await jobApplicantList(jobId);
      setApplications(response?.applications);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  const handleDragStart = (category: any, index: number) => {
    setDraggedApplication({ category, index });
  };

  const handleDrop = (targetCategory: any) => {
    if (!draggedApplication) return;

    const { category: sourceCategory, index } = draggedApplication;

    // Prevent dropping in the same category
    if (sourceCategory === targetCategory) {
      return;
    }

    // Move the dragged application
    const sourceList = [...(applications?.[sourceCategory] || [])];
    const [movedApplication] = sourceList.splice(index, 1);

    const targetList = [...(applications?.[targetCategory] || [])];

    targetList.push(movedApplication);

    // Update the state
    setApplications({
      ...applications,
      [sourceCategory]: sourceList,
      [targetCategory]: targetList,
    });

    setDraggedApplication(null); // Clear dragged item

    applicantStatusChnage(targetCategory, movedApplication?.id);
  };

  //status change thr drag and drop
  const applicantStatusChnage = async (
    targetCategory: string,
    movedApplicationId: string
  ) => {
    try {
      // setLoading(true);
      let payload = {
        status: targetCategory,
      };
      const response = await applicantStatusUpdate(movedApplicationId, payload);
      showSuccess(response?.message);
      fetchjobApplicantListTable(jobId);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
  };

  const getCategoryColor = (category: string) => {
    switch (category) {
      case "applied":
        return "blue";
      case "hired":
        return "green";
      case "interview":
        return "orange";
      case "offered":
        return "light-green";
      case "rejected":
        return "red";
      case "shortlisted":
        return "light-orange";
      default:
        return "gray";
    }
  };

  const downloadResume = (resumeUrl: string = "") => {
    window.open(resumeUrl, "_blank");
  };

  //applicant details
  const handleViewApplication = async (applicationId: any) => {
    handleShow();
    try {
      setIsModalLoading(true);
      const response = await appliedJobDetails(applicationId);
      setApplicantDetails(response?.application);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsModalLoading(false);
    }
  };

  const getInitials = (name: string = "") => {
    const parts = name?.split(" ");
    const firstInitial = parts[0]?.[0]?.toUpperCase() || "";
    const lastInitial = parts[parts.length - 1]?.[0]?.toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  };

  // applicat status change on hired
  const handleClickHire = async (applicationId: string = "") => {
    Alert.confirm(
      "Are you sure you want to change the application status to 'Hired'?"
    ).then(async (resp) => {
      if (resp) {
        try {
          // setLoading(true);
          let payload = {
            status: "hired",
          };
          const response = await applicantStatusUpdate(applicationId, payload);
          showSuccess(response?.message);
          handleClose();
          fetchjobApplicantList();
          fetchjobApplicantListTable(jobId);
        } catch (err: any) {
          showError(err?.message);
        } finally {
          // setLoading(false);
        }
      }
    });
  };

  //status change from view modal
  const handleStatusChange = async (event: any, applicationId: string = "") => {
    const newStatus = event.target.value;
    try {
      // setLoading(true);
      let payload = {
        status: newStatus,
      };
      const response = await applicantStatusUpdate(applicationId, payload);
      showSuccess(response?.message);
      handleClose();
      fetchjobApplicantList();
      fetchjobApplicantListTable(jobId);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  //applicant list for table formate
  const fetchjobApplicantListTable = async (
    jobId: string = "",
    page = 1,
    search = "",
    sortKey = "",
    sortDirection = "",
    itemsPerPage = 10
  ) => {
    try {
      setIsLoading(true);
      const response = await jobApplicantListTable(
        jobId,
        page,
        search,
        sortKey,
        sortDirection,
        itemsPerPage
      );
      const transformed = await transformedData(
        response?.applications?.applications
      );
      setApplicantTableData(transformed);
      setTotalPages(response?.applications?.totalPages);
      setCurrentPage(Number(response?.applications?.page));
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const transformedData = async (applicants: any) => {
    return (
      applicants &&
      applicants?.map((app: any) => ({
        name: (
          <div className="profileholdertable d-flex">
            <div className="profileImg">
              <span>{getInitials(app?.candidate?.name || "N/A")}</span>
            </div>
            <p>{app?.candidate?.name || "N/A"}</p>
          </div>
        ),
        applied_date: app.createdAt
          ? new Date(app.createdAt).toLocaleDateString()
          : "N/A",
        status: (
          <div>
            <select
              className="form-select"
              value={app.status}
              onChange={(e) => handleStatusChange(e, app.id)}
            >
              {statusOptions &&
                statusOptions?.map((status, index) => (
                  <option key={index} value={status}>
                    {_.startCase(_.toLower(status))}
                  </option>
                ))}
            </select>
          </div>
        ),
        position_applied_for: app?.jobID?.category?.categoryName || "N/A",
        post_date: new Date(app?.jobID?.createdAt).toLocaleDateString(), // Format date
        hire_me: (
          <div>
            {app?.status !== "hired" ? (
              <button
                className="btn btn-primary"
                onClick={() => handleClickHire(app?.id)}
              >
                Hire
              </button>
            ) : (
              <button className="btn btn-success" disabled>
                Hired
              </button>
            )}
          </div>
        ),
        actions: (
          <div>
            <Button
              className="btnnoStyle"
              variant="primary"
              onClick={() => downloadResume(app?.candidate?.resume)}
            >
              <LuDownload />
            </Button>

            <Button
              className="btnnoStyle"
              variant="primary"
              onClick={() =>    handleViewApplication(app?.id)}
            >
              <LuEye />
            </Button>

            <Button
              className="btnnoStyle"
              variant="danger"
              onClick={() => handleDelete(app)}
            >
              <AiOutlineDelete />
            </Button>
          </div>
        ),
      }))
    );
  };

  const handlePageChange = (page: number) => {
    fetchjobApplicantListTable(jobId, page);
  };

  const handleSearch = (searchTerm: string) => {
    fetchjobApplicantListTable(jobId, 1, searchTerm); // Reset to the first page when searching
  };

  const handleSort = (key: string, direction: string) => {
    fetchjobApplicantListTable(jobId, 1, "", key, direction); // Reset to the first page when sorting
  };
  const handleItemsPerPageChange = (itemsPerPage: number) => {
    fetchjobApplicantListTable(jobId, 1, "", "", "", itemsPerPage); // Reset to the first page when items per page changes
  };

  const handleDelete = async (row: any) => {
    // console.log("delete application", row?.id);
    Alert.confirm("Are you sure?", "You want to delete this application").then(
      async (resp) => {
        if (resp) {
          try {
            await deleteApplicant(row?.id);
            fetchjobApplicantList();
            fetchjobApplicantListTable(jobId);
          } catch (err: any) {
            showError(err?.message);
          } finally {
            // setLoading(false);
          }
        }
      }
    );
  };

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                <EmployerSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <EmployerHeaderScreen />
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12  position-relative">
                      <div className="applicants-holder d-flex justify-content-between mb-3">
                        <div className="title">
                          <h2>Applicants</h2>
                        </div>
                        {/* <div className="sortby-holder">
                          <h6>Sort By:</h6>
                          <Form.Select aria-label="Default select example">
                            <option>Applied</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </Form.Select>
                        </div> */}
                      </div>
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <Tabs
                          activeKey={activeTab}
                          onSelect={(key: any) => setActiveTab(key)}
                          id="uncontrolled-tab-example"
                          className="mb-3"
                        >
                          <Tab eventKey="home" title="Home">
                            <div className="listviewMain">
                              <div className="appliedJobsTable managejobtable">
                                {/* DATA TABLE */}
                                <DataTable
                                  data={applicantTableData}
                                  columns={columns}
                                  currentPage={currentPage}
                                  totalPages={totalPages}
                                  onPageChange={handlePageChange}
                                  onSearch={handleSearch}
                                  onSort={handleSort}
                                  onItemsPerPageChange={
                                    handleItemsPerPageChange
                                  }
                                />
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="profile" title="Profile">
                            <div className="gridviewMain">
                              <Row>
                                {Object.keys(applications || {}).map(
                                  (category) => (
                                    <Col
                                      lg
                                      className={`colour-${getCategoryColor(
                                        category
                                      )}`}
                                      key={category}
                                      onDragOver={handleDragOver}
                                      onDrop={() => handleDrop(category)}
                                    >
                                      <button
                                        className={`btn w-100 btn-${getCategoryColor(
                                          category
                                        )}`}
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {category}
                                      </button>
                                      <div className="cardHolder">
                                        {applications[category] &&
                                          applications[category]?.map(
                                            (
                                              application: any,
                                              index: number
                                            ) => (
                                              <Card
                                                className="kanban"
                                                key={application.id}
                                                draggable
                                                onDragStart={() =>
                                                  handleDragStart(
                                                    category,
                                                    index
                                                  )
                                                }
                                                style={{
                                                  padding: "10px",
                                                  margin: "5px 0",
                                                  backgroundColor: "#fff",
                                                  border: "1px solid #ddd",
                                                  cursor: "move",
                                                }}
                                              >
                                                <Card.Body>
                                                  <div className="profileholdertable d-flex">
                                                    <div className="profileImg">
                                                      <span>
                                                        {getInitials(
                                                          application?.candidate
                                                            ?.name
                                                        )}
                                                      </span>
                                                    </div>
                                                    <h6>
                                                      {
                                                        application?.candidate
                                                          ?.name
                                                      }{" "}
                                                      <span>
                                                        {application?.jobID
                                                          ?.title || "N/A"}
                                                      </span>
                                                    </h6>
                                                  </div>
                                                  <div className="datelinks">
                                                    {/* <p>Sep 15, 2024</p> */}
                                                    <p>
                                                      {moment(
                                                        application?.createdAt
                                                      ).format("MMM DD, YYYY")}
                                                    </p>
                                                    <ul className="d-flex">
                                                      <li>
                                                        <Button
                                                          className="btnnoStyle"
                                                          variant="primary"
                                                          onClick={() =>
                                                            downloadResume(
                                                              application
                                                                ?.candidate
                                                                ?.resume
                                                            )
                                                          }
                                                        >
                                                          <LuDownload />
                                                        </Button>
                                                      </li>
                                                      <li>
                                                        <Button
                                                          className="btnnoStyle"
                                                          variant="primary"
                                                          onClick={() =>
                                                            handleViewApplication(
                                                              application?.id
                                                            )
                                                          }
                                                        >
                                                          <LuEye />
                                                        </Button>
                                                      </li>
                                                      <li>
                                                        <Button
                                                          className="btnnoStyle text-red"
                                                          variant="primary"
                                                          onClick={() =>
                                                            handleDelete(
                                                              application
                                                            )
                                                          }
                                                        >
                                                          <AiOutlineDelete />
                                                        </Button>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </Card.Body>
                                              </Card>
                                            )
                                          )}
                                      </div>
                                    </Col>
                                  )
                                )}
                              </Row>
                            </div>
                          </Tab>
                        </Tabs>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        {/* Close Button */}
        {applicantDetails && (
          <>
            <button
              type="button"
              className="btn-close custom-close-btn"
              onClick={handleClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                zIndex: 9,

                border: "none",
                fontSize: "1rem",
                cursor: "pointer",
              }}
            ></button>

            <Modal.Body>
              {/* {applicantDetails && ( */}
              <div className="afterapplied">

                  {isModalLoading ? (
                    <Loader />
                  ) : (
                <div className="aplyinfo">
                  <div className="profileholdertable mb-4 large d-flex">
                    <div className="d-flex align-items-center">
                      <div className="profileImg">
                        <img
                          src={
                            applicantDetails?.application?.userID
                              ?.profileimageurl
                              ? applicantDetails?.application?.userID
                                  ?.profileimageurl
                              : UserProfileNoImg
                          }
                          alt="profile"
                        />
                      </div>
                      <div className="ppname">
                        <h4>
                          {applicantDetails?.application?.candidate?.name ||
                            "N/A"}
                        </h4>
<div className="ppnameholder" style={{display:"flex", alignItems:"center", columnGap:"0"}}>
                        <select
                          className="success"
                          id="status-select"
                          value={applicantDetails?.application?.status}
                          onChange={(e) =>
                            handleStatusChange(
                              e,
                              applicantDetails?.application?.id
                            )
                          }
                          style={{
                            padding: "0.5rem 1rem 0.5rem 0.5rem",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            backgroundPosition:" 5px 50px"
                            }}
                        >
                          {statusOptions &&
                            statusOptions?.map((status, index) => (
                              <option key={index} value={status}>
                                {_.startCase(_.toLower(status))}
                              </option>
                            ))}
                        </select>
<div className="downloadcv">
                      <Button
                        className="btnnoStyle"
                        variant="primary"
                        onClick={() =>
                          downloadResume(applicantDetails?.application?.candidate?.resume)
                        }
                        disabled={!applicantDetails?.application?.candidate?.resume}
                      >
                        <LuDownload style={{ opacity: !applicantDetails?.application?.candidate?.resume ? 0.6 : 1}}/>
                      </Button>
                    </div>
                    </div>



                        {/* <button className="success">
                      {_.startCase(
                        _.toLower(applicantDetails?.application?.status)
                      )}
                      <FaChevronDown />
                    </button> */}
                      </div>
                    </div>
                    
                  </div>
                  <h4>
                    <strong>Candidate Name:</strong>{" "}
                    {applicantDetails?.application?.candidate?.name || "N/A"}
                  </h4>
                  <h4>
                    <strong>Email Address:</strong>{" "}
                    {applicantDetails?.application?.candidate?.email || "N/A"}
                  </h4>
                  <h4>
                    <strong>Phone Number:</strong>{" "}
                    {applicantDetails?.application?.candidate?.contact || "N/A"}
                  </h4>
                  <h4>
                    <strong>Applied Date:</strong>{" "}
                    {applicantDetails?.application?.createdAt
                      ? moment(applicantDetails?.application?.createdAt).format(
                          "MMM DD, YYYY"
                        )
                      : "N/A"}
                  </h4>
                  <h4>
                    <strong>Position Applied For:</strong>{" "}
                    {applicantDetails?.application?.jobID?.category
                      ?.categoryName || "N/A"}
                  </h4>
                  <h4>
                    <strong>Post Date: </strong>
                    {applicantDetails?.application?.jobID?.createdAt
                      ? moment(
                          applicantDetails?.application?.jobID?.createdAt
                        ).format("MMM DD, YYYY")
                      : "N/A"}
                  </h4>
                  <h4>
                    <strong>Experience Level:</strong>{" "}
                    {applicantDetails?.application?.candidate?.explevel || "0"}{" "}
                  </h4>
                  {applicantDetails?.application?.status!=="hired" && (
                  <div className="flex-btn d-flex">
                    <Button
                      className="btn w-100"
                      variant="primary"
                      onClick={() => {
                        handleClickHire(applicantDetails?.application?.id);
                      }}
                    >
                      Hire Me
                    </Button>
                  </div>
                  )}
                </div>)}
              </div>
              {/* )} */}
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
};
export default EmpApplicantsScreen;
